import React, { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { setTokens } from '../lib/api';
import { useAuth } from '../contexts/AuthContext';

export default function AuthCallback() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const { refreshProfile } = useAuth();

  useEffect(() => {
    const accessToken  = searchParams.get('access_token');
    const refreshToken = searchParams.get('refresh_token');
    const error        = searchParams.get('error');

    if (error || !accessToken || !refreshToken) {
      navigate('/login?error=' + (error || 'auth_failed'), { replace: true });
      return;
    }

    setTokens(accessToken, refreshToken);
    refreshProfile().then(() => navigate('/', { replace: true }));
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <div className="app-loading">
      <div className="app-loading-spinner" />
      <p>Signing in…</p>
    </div>
  );
}
